(function () {
  'use strict';

  if (window.__kcProductCardInit) return;
  window.__kcProductCardInit = true;

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-kc-cart-form]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '\u2026';

    var formData = new FormData(form);

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          btn.textContent = data.description || 'Error';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
          return;
        }

        btn.textContent = 'Hinzugefügt';
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);

        var quantity = parseInt(formData.get('quantity')) || 1;
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: form.querySelector('[name="id"]').value,
            data: {
              source: 'product-form-component',
              itemCount: quantity,
              productId: form.closest('.kc-product-card')
                ? form.closest('.kc-product-card').dataset.productId
                : ''
            }
          }
        }));
      })
      .catch(function () {
        btn.textContent = 'Error';
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      });
  });
})();
